import React from 'react';
import {Filter, ReferenceInput, SelectInput, DateInput} from 'react-admin';
import {COLUMN_CATEGORY, COLUMN, ARTICLE_STATES, ARTICLE_SECTION} from '../../consts/Names';


export const ColumnsFilters = (props) => (
   <Filter {...props}>
      <ReferenceInput label="Category" source={COLUMN_CATEGORY.source_name} reference={COLUMN_CATEGORY.SOURCE}>
         <SelectInput optionText="name" />
      </ReferenceInput>
      <SelectInput source="state" label="State of publish" allowEmpty={false} choices={ARTICLE_STATES} />
      <SelectInput
         label="Section"
         source={COLUMN.section}
         allowEmpty={false}
         choices={[
            {id: ARTICLE_SECTION.CAROUSEL, name: 'not highlight'},
            {id: ARTICLE_SECTION.HIGHTLIGHT, name: ARTICLE_SECTION.HIGHTLIGHT}
         ]}
      />
      <DateInput source={COLUMN.created_at} label="Date of creation" defaultValue={new Date().toISOString().substring(0, 10)} reference={COLUMN.SOURCE} />
   </Filter>
);
